export const comments_5256808 = {"data":{"data":[],"links":{}}}